import React from 'react';
import { Container } from '@xo-union/tk-component-grid';
import { ActionItem } from '../../libs/gs-component-form';

import styles from './remover.scss';

interface Props {
  onClick: () => void;
  children: React.ReactNode | React.ReactNode[] | null;
}

const Remover: React.FC<Props> = ({ onClick, children }) => (
  <Container className={styles.removeContainer}>
    <ActionItem type="remove" onClick={onClick}>
      {children}
    </ActionItem>
  </Container>
);

export default Remover;
